export default "__VITE_ASSET__BPw9DS0i__"